(function ($) {
  "use strict";

  // bThis is just a test

  jQuery(document).ready(function ($) {


    //Waiting for images to be loaded
    $(window).on("load", function () {
      $("#loading").slideUp();
      $("#slides").fadeIn("slow");
      //Prevent having no "active" slide
      var $el = $(".toggle.activee");
      if (!$el.length) {
        $(".toggle").first().addClass("activee");
      }
    });

    // $("#previous").click(function () {
    //   var $el = $(".activee").prev(".toggle");
    //   if (!$el.length) {
    //     $el = $(".toggle").last();
    //   }
    //   $(".activee").removeClass("activee");
    //   $el.addClass("activee");
    // });

    // $("#next").click(function () {
    //   var $el = $(".activee").next(".toggle");
    //   if (!$el.length) {
    //     $el = $(".toggle").first();
    //   }
    //   $(".activee").removeClass("activee");
    //   $el.addClass("activee");
    // });

    // made__slider owl js

    $(".made__slider__active").owlCarousel({
      loop: true,
      margin: 10,
      stagePadding: 280,
      nav: true,
      navText: [
        '<i class="far fa-arrow-left"></i>',
        '<i class="far fa-arrow-right"></i>',
      ],
      responsive: {
        0: {
          items: 3,
          stagePadding: 0,
        },
        600: {
          items: 3,
          stagePadding: 50,
        },
        1000: {
          items: 3,
        },
        2560: {
          items: 4,
          stagePadding: 280, // Adjust this value as needed
        },
        3840: {
          items: 4,
          stagePadding: 280, // Adjust this value as needed
        },
      },
    });

    // testimonial__slider owl js

    $(".testimonial__active").owlCarousel({
      loop: false,
      items: 4,
      margin: 10,
      stagePadding: 0,
      nav: false,
      dotsData: false,
      dots: true,
      navText: [
        '<i class="far fa-arrow-left"></i>',
        '<i class="far fa-arrow-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
          stagePadding: 70,
          loop: true,
        },
        600: {
          items: 2,
          stagePadding: 100,
          loop: true,
        },
        1000: {
          items: 3,
        },
      },
    });
    // best-slider owl js

    $(".best__slider__active").owlCarousel({
      loop: true,
      items: 5,
      margin: 0,
      stagePadding: 0,
      nav: false,
      autoplay: true,
      dotsData: false,
      autoplaySpeed: 3000,
      dots: false,
      navText: [
        '<i class="far fa-arrow-left"></i>',
        '<i class="far fa-arrow-right"></i>',
      ],
      responsive: {
        0: {
          items: 3,
          stagePadding: 20,
        },
        600: {
          items: 3,
        },
        1000: {
          items: 5,
        },
      },
    });
    // best-slider owl js

    $(".brand__slider__active").owlCarousel({
      loop: true,
      items: 3,
      margin: 0,
      stagePadding: 0,
      nav: false,
      autoplay: true,
      dotsData: false,
      autoplaySpeed: 3000,
      dots: false,
      navText: [
        '<i class="far fa-arrow-left"></i>',
        '<i class="far fa-arrow-right"></i>',
      ],
      responsive: {
        0: {
          items: 2,
          stagePadding: 50,
        },
        600: {
          items: 2,
          stagePadding: 50,
        },
        1000: {
          items: 2,
          stagePadding: 50,
        },
      },
    });

    // free-slider owl js

    $(".free__slider__active").owlCarousel({
      loop: true,
      items: 3,
      margin: 0,
      stagePadding: 0,
      nav: false,
      autoplay: true,
      dotsData: false,
      autoplaySpeed: 3000,
      dots: false,
      navText: [
        '<i class="far fa-arrow-left"></i>',
        '<i class="far fa-arrow-right"></i>',
      ],
      responsive: {
        0: {
          items: 2,
          stagePadding: 20,
        },
        600: {
          items: 2,
          stagePadding: 20,
        },
        1000: {
          items: 2,
          stagePadding: 20,
        },
      },
    });

    // You can also pass an optional settings object
    // below listed default settings
    AOS.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
      initClassName: "aos-init", // class applied after initialization
      animatedClassName: "aos-animate", // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 400, // values from 0 to 3000, with step 50ms
      easing: "ease", // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    $(function () {
      $.scrollUp({
        scrollName: "scrollUp", // Element ID
        topDistance: "300", // Distance from top before showing element (px)
        topSpeed: 300, // Speed back to top (ms)
        animation: "fade", // Fade, slide, none
        animationInSpeed: 200, // Animation in speed (ms)
        animationOutSpeed: 200, // Animation out speed (ms)
        scrollText:
          "<img src='" + scrollToTopImageUrl + "' alt='Scroll to top'/>", // Use image tag here
        activeOverlay: false, // Set CSS color to display scrollUp active point, e.g '#00FFFF'
      });
    });

    $(window).on("scroll", function () {
      var scroll = $(window).scrollTop();
      if (scroll < 3050) {
        $(".header__sticky").removeClass("scroll-header");
      } else {
        $(".header__sticky").addClass("scroll-header");
      }
    });

    //---owl dots number-----

    var i = 1;

    $(".hero-slier-main.owl-carousel .owl-dot").each(function () {
      $(this).text(i);
      i++;
    });

    // --- Synced Owl Carousel for Product Gallery (from script.js) ---
    var sync1 = $("#sync1");
    var sync2 = $("#sync2");
    var slidesPerPage = 3; //globaly define number of elements per page
    var syncedSecondary = true;

    sync1
      .owlCarousel({
        items: 1,
        nav: false,
        autoplay: false,
        smartSpeed: 2000,
        dots: false,
        autoWidth: false,
        loop: true,
        responsiveRefreshRate: 200,
      })
      .on("changed.owl.carousel", syncPosition);

    sync2
      .on("initialized.owl.carousel", function () {
        sync2.find(".owl-item").eq(0).addClass("current");
      })
      .owlCarousel({
        items: slidesPerPage,
        dots: false,
        nav: false,
        margin: 5,
        loop: false,
        center: false,
        autoWidth: true,
        smartSpeed: 2000,
        slideBy: 1, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
        responsiveRefreshRate: 100,
      })
      .on("changed.owl.carousel", syncPosition2);

    function syncPosition(el) {
      var count = el.item.count - 1;
      var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

      if (current < 0) {
        current = count;
      }
      if (current > count) {
        current = 0;
      }

      sync2
        .find(".owl-item")
        .removeClass("current")
        .eq(current)
        .addClass("current");
      var onscreen = sync2.find(".owl-item.active").length - 1;
      var start = sync2.find(".owl-item.active").first().index();
      var end = sync2.find(".owl-item.active").last().index();

      if (current > end) {
        sync2.data("owl.carousel").to(current, 100, true);
      }
      if (current < start) {
        sync2.data("owl.carousel").to(current - onscreen, 100, true);
      }
    }

    function syncPosition2(el) {
      if (syncedSecondary) {
        var number = el.item.index;
        sync1.data("owl.carousel").to(number, 100, true);
      }
    }

    sync2.on("click", ".owl-item", function (e) {
      e.preventDefault();
      var number = $(this).index();
      sync1.data("owl.carousel").to(number, 300, true);
    });
  }); //---document-ready-----
})(jQuery);
